module.exports = global["jQuery"] = require("-!C:\\Users\\Frontend\\Downloads\\OSPanel\\domains\\sbctech\\node_modules\\source-map-loader\\index.js!C:\\Users\\Frontend\\Downloads\\OSPanel\\domains\\sbctech\\node_modules\\source-map-loader\\index.js!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/source-map-loader!./~/jquery/dist/jquery.js-exposed
// module id = 56
// module chunks = 0 1 8 20